import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";

const BlogSectionfoot = () => {
  const blogs = [
    {
      img: "/images/keyword/5.jpg",
      title: "Pune to Mumbai Cabs",
      text: "Choose Platinum24 Cabs for a smooth and reliable Pune to Mumbai ride. Whether you're heading to the airport, attending a business meeting, or visiting family, we provide clean, comfortable cabs, trained drivers, and 24/7 service for a hassle-free intercity trip.",
      href: "/pune-to-mumbai-cabs",
    },
    {
      img: "/images/keyword/8.jpg",
      title: "Pune to Lonavala Cabs",
      text: "Enjoy a scenic and stress-free ride from Pune to Lonavala with Platinum24 Cabs. Whether it’s a quick getaway or a weekend trip, our professional drivers and well-maintained cabs ensure a smooth, comfortable journey at affordable rates — available 24/7.",
      href: "/pune-to-lonavala-cabs",
    },
    {
      img: "/images/keyword/14.jpg",
      title: "Pune to Goa Cabs",
      text: "Planning a beach getaway? Ride in comfort from Pune to Goa with Platinum24 Cabs. Enjoy spacious cars, experienced drivers, and doorstep pickup for a safe and scenic long-distance journey — perfect for vacations, group trips, or weekend escapes.",
      href: "/pune-to-goa-cabs",
    },
  ];

  return (
    <section className="-extra-bottom blog-wrapper ">
      <div className="container">
        {/* Section Title */}
        <div className="row justify-content-center text-center">
          <div className="col-xl-6 col-lg-8 wow fadeInUp " data-wow-delay="0.3s">
            <div className="title-area">
              <span className="sec-subtitle">Blogs</span>
              <h2 className="sec-title h1">Our Latest Blog</h2>
            </div>
          </div>
        </div>

        {/* Swiper Slider for Blogs */}
        <Swiper
          modules={[Autoplay]}
          autoplay={{ delay: 3500, disableOnInteraction: false }}
          loop={true}
          spaceBetween={30}
          breakpoints={{
            320: { slidesPerView: 1 },
            576: { slidesPerView: 2 },
            992: { slidesPerView: 2 },
            1200: { slidesPerView: 3 },
          }}
          className="row vs-carousel"
        >
          {blogs.map((blog, idx) => (
            <SwiperSlide key={idx} className="col-xl-4  ">
              <div className="vs-blog blog-style3  bg-or">
                <div className="blog-img borderr ">
                  <a href={blog.href}>
                    <img src={blog.img} alt="blog" />
                  </a>
                </div>
                <div className="blog-content ">
                  <h2 className="blog-title">
                    <a className="text-bor" href={blog.href}>{blog.title}</a>
                  </h2>
                  <p className="blog-text text-white">{blog.text}</p>
                  <div className="blog-bottom">
                    <a className="blog-date" href={blog.href}>
                      <img
                        src="/images/logo.jpg"
                        alt="Platinum24 Cabs Logo"
                        style={{ height: "20px", width: "auto" }}
                      />
                    </a>
                    <a className="vs-btn style4" href={blog.href}>
                      Read More <i className="fal fa-arrow-right"></i>
                    </a>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default BlogSectionfoot;
